import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bxl-organization-admin-wrapper',
  templateUrl: 'organization-admin-wrapper.component.html',
})
export class OrganizationAdminWrapperComponent implements OnInit {
  initialized = false;
  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
